import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { payment_api } from "../Payments.constants";
import { IPaymentInstallmentApiresponse } from "../Payments.interface";

export const callGetPaymentInstallmentsApi = ({
    listingUuid,
    currency,
    discountCode: discount_code,
    appliedCount: applied_count,
}: {
    listingUuid: string;
    currency?: string;
    discountCode?: string;
    appliedCount?: number;
}): Promise<{ data: IPaymentInstallmentApiresponse }> =>
    callApi({
        url: `${payment_api.get_installment_details}/${listingUuid}`,
        method: CALL_API_METHODS.GET,
        params: { currency, discount_code, applied_count },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
